export const entry = {
  state: {
    init: {
      description:
        'Entry point - elemen kunci dari skema yang bertanggung jawab untuk menerima panggilan. Panggilan kemudian ditransfer sesuai dengan skema untuk diproses lebih lanjut. Pada entry point, Anda harus menentukan nomor yang harus Anda panggil untuk mendapatkan skema routing.'
    },
    ['create-number']: {
      title: 'Tambah nomor extensi'
    }
  },
  input: {
    number_id: {
      label: 'Nomor Entry point',
      tooltip: 'Nomor titik masuk adalah nomor yang dapat Anda panggil untuk menghubungkan PBX.'
    },

    hide_incoming_number: {
      label: 'Sembunyikan nomor'
    },

    caller_id: {
      label: 'Nomor Keluar',
      tooltip: 'Nomor keluar (Caller ID) adalah nomor yang akan ditampilkan kepada klien ketika dia menerima panggilan masuk.'
    },

    record: {
      label: 'Semua panggilan direkam'
    },

    calls_only: {
      label: 'Merekam hanya panggilan langsung',
      description:
        'Merekam panggilan dengan dua atau lebih peserta. Kecualikan perekaman layanan otomatis.'
    },

    links:{
      label: 'Beli Paket Service'
    }
  }
};
